import { render, staticRenderFns } from "./ItemSelector.vue?vue&type=template&id=5f6af4a2&scoped=true&"
import script from "./ItemSelector.vue?vue&type=script&lang=js&"
export * from "./ItemSelector.vue?vue&type=script&lang=js&"
import style0 from "./ItemSelector.vue?vue&type=style&index=0&id=5f6af4a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6af4a2",
  null
  
)

export default component.exports